// extracted by mini-css-extract-plugin
export default {"card":"Card_card__BkUts","card__dots":"Card_card__dots__bo7Xs","card__ico":"Card_card__ico__lf5s3","card__title":"Card_card__title__jU6-Y"};